import { Vue, Component, Watch, Prop, Inject, Provide } from 'vue-property-decorator';
import style from './style.vue';
import { RenovationColorList } from '@/views/components/styleConfig';
import { numberToArray } from '@/util';

export enum ShowWindowShowType {
  LINE = 1, // 一行2个
  SCROLL, // 横向滚动
  BIG, // 大图
}

@Component({
  components: {},
  mixins: [style],
})
export default class ShowWindow extends Vue {
  @Prop({ default: () => {} })
    value: DisplayShowWindowData | DisplayShowWindowGroupData;

  @Prop({ default: 1 })
    themeCode: number;

  @Inject({
    default: () => {
      return () => {
        return { selected: -1 };
      };
    },
  })
    shopDisplayTree;

  @Prop()
    backGroundColor: string;

  get getTheme() {
    return RenovationColorList[this.themeCode];
  }

  getShopPageTypeClass(type) {
    switch (type) {
      case ShowWindowShowType.BIG:
        return 'big-pri';
      case ShowWindowShowType.LINE:
        return 'lineTwo';
      case ShowWindowShowType.SCROLL:
        return 'scroll';
    }
  }

  // 运营模式 1 镜单  2 镜千 3 云单 4 云千
  @Provide()
  get mode() {
    return Number(+this.$route.params.mode);
  }

  @Provide()
  get isMoreSite() {
    return Number(+this.$route.params.isMoreSite);
  }

  mounted() {
    // console.log("youjige",this.value)
  }

  render(h) {
    // 商品橱窗位显示方式 1一行两个 2横向滚动 3大图
    const style = `${this.getShopPageTypeClass(this.value.desc.caseStyle)} window-list`;
    const caseGroup = (this.value as DisplayShowWindowGroupData).desc.caseGroup || [];
    let findIndex = caseGroup.findIndex(v => this.shopDisplayTree().selected === (v.sgwpId || v.sgmpId));
    findIndex = findIndex === -1 ? 0 : findIndex;

    return (
      <div
        class="show-window"
        style={{
          paddingBottom: this.value.desc.style && this.value.desc.style.includes('center') ? '10px' : '',
          backgroundColor: this.backGroundColor,
          color: this.getTheme[2] === '#000' ? '#fff' : '#000',
          borderColor: this.getTheme[2] === '#000' ? '#fff' : '#000',
        }}>
        {this.value.fieldType === 'ShowWindow' && (
          <div>
            <p class="title">
              <span
                style={{ fontSize: `${this.value.desc.fontSize / 2}px`, flex: 1, padding: '6px 0', textIndent: '5px' }}
                class={{
                  'rs-f-b': this.value.desc.style.includes('bold'),
                  'rs-t-c': this.value.desc.style.includes('center'),
                }}>
                {this.value.desc.caseName}
              </span>
              {!this.value.desc.style.includes('center') && <i class="el-icon-arrow-right" />}
            </p>
          </div>
        )}
        {this.value.fieldType === 'ShowWindowGroup' && (
          <div class="window-case-nav width-100 r-mb-8">
            {((this.value as DisplayShowWindowGroupData).desc.caseGroup || []).map((v, i) => {
              return (
                <div class="window-case-tab" style={`color: ${findIndex === i ? '' : '#999999'}`}>
                  {v.caseName}
                  {findIndex === i && <div class="under-line"></div>}
                </div>
              );
            })}
          </div>
        )}
        <div class={style}>
          {numberToArray(this.value.desc.caseNum).map(() => {
            return <div class="window-item" />;
          })}
        </div>
        {!!this.value.desc.isShowMore && this.value.fieldType === 'ShowWindowGroup' && (
          <div class="more">
            <span>查看更多</span>
            <i class="el-icon-arrow-right" />
          </div>
        )}
        {this.value.desc.style.includes('center') && this.value.fieldType === 'ShowWindow' && (
          <div class="more">
            <span>查看更多</span>
            <i class="el-icon-arrow-right" />
          </div>
        )}
      </div>
    );
  }
}
